import React from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import TitleProducts from '../components/TitleProducts/TitleProducts';
import InfoCardsMagicBento from '../components/InfoCardsMagicBento/InfoCardsMagicBento';
import ProductCards from '../components/ProductCards/ProductCards';
import DownloadCatalog from '../components/DownloadCatalog/DownloadCatalog';
import { useProducts } from '../hooks/useProducts';
import styles from './CategoryPage.module.css';

const categoryTitles = {
  nitrilo: 'Nitrilo',
  esteriles: 'Estériles',
  domesticos: 'Domésticos',
  pe: 'PE',
  vinilo: 'Vinilo',
  'natural-latex': 'Natural Latex',
};

export default function CategoryPage() {
  const { category } = useParams();
  const navigate = useNavigate();
  const { products, loading, error } = useProducts(category);
  const title = categoryTitles[category] || 'Guantes';

  const handleProductClick = (product) => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
    // Usar el id si existe (del JSON o generado en AdminPanel), si no usar firestoreId
    const productId = product.id || product.firestoreId;
    navigate(`/producto/${productId}`);
  };

  if (loading) {
    return (
      <div className={styles.pageContainer}>
        <div style={{ 
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          padding: '80px 20px',
          minHeight: '400px'
        }}>
          <div style={{
            width: '40px',
            height: '40px',
            border: '4px solid #8ec9c3',
            borderTop: '4px solid #c9298e',
            borderRadius: '50%',
            animation: 'spin 1s linear infinite'
          }}></div>
          <style>{`
            @keyframes spin {
              0% { transform: rotate(0deg); }
              100% { transform: rotate(360deg); }
            }
          `}</style>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className={styles.pageContainer}>
        <div style={{ textAlign: 'center', padding: '60px 20px', color: '#ff6b6b' }}>
          <h2>Error al cargar productos: {error}</h2>
        </div>
      </div>
    );
  }
  return (
    <div className={styles.pageContainer}>
      <TitleProducts title={title} />
      <div className={styles.productsGrid}>
        {products.map((product, idx) => (
          <div
            key={product.id || product.firestoreId}
            className={styles.productCard + ' ' + styles.fadeIn}
            style={{ animationDelay: `${idx * 0.08}s`, cursor: 'pointer' }}
            onClick={() => handleProductClick(product)}
          >
            <div className={styles.productTitle}>{product.title}</div>
            <img src={product.image} alt={product.title} className={styles.productImgLarge} />
          </div>
        ))}
      </div>
      <h2 className={styles.sectionTitle}>Categorías de guantes</h2>
      <ProductCards />
      <InfoCardsMagicBento />
      <DownloadCatalog />
    </div>
  );
}
